import { FileText, Lock } from "lucide-react";
import Logo from "./Logo";
import { scrollToHash } from "./Header";

export default function Footer({ tagline = "" }) {
  const text = tagline || "Voogly Education — India ka apna digital study store. Topper notes, PDFs aur video courses, sab ek jagah. Pay karein Razorpay se, download turant.";
  return (
    <footer className="bg-ink text-white pb-10 pt-20 relative overflow-hidden">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <Logo subtitle />
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-slate-400">{text}</p>
          </div>
          <div className="md:col-span-3">
            <p className="font-mono text-[11px] uppercase tracking-[0.22em] text-amber-400">Explore</p>
            <ul className="mt-5 space-y-3 text-sm text-slate-300">
              <li><a href="#featured" onClick={(e) => { e.preventDefault(); scrollToHash("#featured"); }} className="hover:text-amber-400">Featured Bundles</a></li>
              <li><a href="#catalog" onClick={(e) => { e.preventDefault(); scrollToHash("#catalog"); }} className="hover:text-amber-400">Full Store</a></li>
              <li><a href="#reviews" onClick={(e) => { e.preventDefault(); scrollToHash("#reviews"); }} className="hover:text-amber-400">Student Reviews</a></li>
              <li><a href="#previews" onClick={(e) => { e.preventDefault(); scrollToHash("#previews"); }} className="hover:text-amber-400">JPG Previews</a></li>
              <li><a href="#youtube" onClick={(e) => { e.preventDefault(); scrollToHash("#youtube"); }} className="hover:text-amber-400">YouTube Hub</a></li>
              <li><a href="/practice" data-testid="footer-practice-link" className="hover:text-amber-400">Free MCQ Practice</a></li>
              <li><a href="/blog" data-testid="footer-blog-link" className="hover:text-amber-400">Exam Tips Blog</a></li>
            </ul>
          </div>
          <div className="md:col-span-4">
            <p className="font-mono text-[11px] uppercase tracking-[0.22em] text-amber-400">Payments & Delivery</p>
            <ul className="mt-5 space-y-3 text-sm text-slate-300">
              <li className="flex items-center gap-2"><FileText size={15} className="text-emerald-400" /> Instant PDF download after payment</li>
              <li className="flex items-center gap-2"><Lock size={15} className="text-emerald-400" /> Razorpay + UPI secured payments</li>
            </ul>
          </div>
        </div>
        <div className="mt-16 flex flex-col sm:flex-row items-center justify-between gap-4 border-t border-white/10 pt-8">
          <p className="font-mono text-[11px] uppercase tracking-[0.18em] text-slate-500">© 2026 Voogly Education</p>
          <a href="/admin" className="inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.18em] text-slate-500 hover:text-amber-400" data-testid="footer-admin-link">
            <Lock size={12} /> Owner Login
          </a>
        </div>
      </div>
    </footer>
  );
}
